import styled from 'styled-components';
import Card from '$app/components/vendor/Card';

export const ReminderCard = styled(Card)`
  margin-bottom: 16px;
  line-height: 1;
`;
